/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Back_To_HomeInputs */

const de_commons_error_page_back_to_home = /** @type {(inputs: Commons_Error_Page_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Konto`)
};

/** @type {(inputs: Commons_Error_Page_Back_To_HomeInputs) => LocalizedString} */
const en_commons_error_page_back_to_home = de_commons_error_page_back_to_home;

/**

* @param {Commons_Error_Page_Back_To_HomeInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_back_to_home = /** @type {((inputs?: Commons_Error_Page_Back_To_HomeInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Back_To_HomeInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_back_to_home(inputs)
	return en_commons_error_page_back_to_home(inputs)
});